import React, { useState } from 'react';
import { Popover } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { getQuery } from '@/common/utils';
import env from '@/env';
import { useHistory } from 'react-router-dom';
import detailApi from '../../api';
import './index.less';
import { message } from 'antd';

export default function HandleSource(props) {
  const {
    record: { materialSourceStr, id, materialSource, ext },
    type,
  } = props;
  const channelId = getQuery('channelId');
  const resourceId = getQuery('resourceId');
  const activityId = getQuery('activityId');
  const history = useHistory();

  const [popContent, setPopContent] = useState(' ');

  const getRootPath = () => {
    var curPageUrl = window.document.location.href;
    var rootPath = curPageUrl.split('//')[1].split('/')[1];
    return rootPath;
  };

  const handleCollectionList = (poolId) => {
    window.open(
      `/${getRootPath()}/myCreate/daily-activities-manager/qualification?activityId=${activityId}&blockId=${poolId}`
    );
  };

  async function handleOnVisibleChange(visible) {
    if (!visible) {
      return false;
    }
    const {
      ret,
      data: { ruleNames, sortNames, poolId, BiDisplay },
      msg,
    } = await detailApi.resourceQuerySourceInfo({
      sourceType: materialSource, // 0 默认人工 1 提报 2 规则圈选
      groupId: id,
      groupType: type,
    });
    if (ret !== '0') {
      return false;
    } else {
      /* 分配提报 */
      if (materialSource === '1' && poolId) {
        setPopContent(
          <div className="handle-source-pool-content-fa">
            <div className="pool-header">
              <span className="poolName">收品池ID：</span>
              <span className="poolId">{poolId || ''}</span>
            </div>
            <a className="pool-href" onClick={() => handleCollectionList(poolId)}>
              查看收品池资质设置规则&gt;
            </a>
          </div>
        );
      } else if (materialSource === '2') {
        if (!ruleNames || !sortNames) {
          setPopContent('暂无数据');
          return;
        }
        ///* 规则圈选、规则邀约 */
        setPopContent(
          <>
            <ResourceShowList title={'素材规则'} itemList={computedRuleNames(ruleNames) || []}></ResourceShowList>
            <ResourceShowList title={'关联规则'} itemList={sortNames || []}></ResourceShowList>
          </>
        );
      } else if (materialSource === '4') {
        /* 人工不需要 */
        // setPopContent(
        //   <>
        //     <ResourceShowList title={'素材规则'} itemList={computedRuleNames(ruleNames) || []}></ResourceShowList>
        //     <ResourceShowList title={'关联规则'} itemList={sortNames || []}></ResourceShowList>
        //   </>
        // );
      } else if (materialSource === '5') {
        setPopContent(
          <div className="handle-source-pool-content-fa">
            <div>{BiDisplay || ''}</div>
          </div>
        );
      }
    }
  }

  function computedRuleNames(ruleNames) {
    let computedRule = [];
    if (ruleNames && Array.isArray(ruleNames) && ruleNames.length > 0) {
      ruleNames.forEach((item, index) => {
        const { ruleContent = [] } = item;
        if (ruleContent && Array.isArray(ruleContent) && ruleContent.length > 0) {
          computedRule = [...computedRule, ...ruleContent];
        }
      });
    }
    return computedRule;
  }

  const handleClick = async () => {
    if (materialSource === '1') {
      history.replace(
        `/${getRootPath()}/myCreate/daily-activities-manager/materials/distribute?activityId=${activityId}`
      );
      return;
    }
    if (materialSource === '2') {
      if (ext?.poolType === 109 && ext?.rankRuleId) {
        window.open(`${env.RANK_LIST}/ace?poolId=${ext?.rankRuleId}`);
        return;
      }
      const {
        ret,
        data: { poolType, subCode },
      } = await detailApi.resourceQuerySourceInfo({
        materialSource, // 0 默认人工 1 提报 2 规则圈选
        groupId: id,
        groupType: type,
      });
      if (ret === '0' && subCode === '0') {
        if (!poolType) {
          return;
        }
        window.open(`${env.ACE_DOMAIN}/pandora/#/integration/manage/${poolType}`);
      } else {
        message.info('查询失败');
      }
    }
  };

  if (materialSource === '4') {
    return materialSourceStr;
  }

  if (ext?.poolType === 109) {
    return (
      <div style={{ cursor: 'pointer' }} onClick={() => handleClick()}>
        <a>{materialSourceStr}</a>
      </div>
    );
  }

  return (
    <>
      {
        <Popover
          content={popContent}
          onVisibleChange={handleOnVisibleChange}
          overlayStyle={{ width: '320px', maxHeight: '260px' }}
          overlayInnerStyle={{ overflow: 'hidden auto', maxHeight: '236px' }}
        >
          <div style={{ cursor: 'pointer' }} onClick={() => handleClick()}>
            {materialSource === '2' || materialSource === '1' ? (
              <a>{materialSourceStr}</a>
            ) : (
              <span>{materialSourceStr}</span>
            )}
            {materialSource !== '4' && <InfoCircleOutlined style={{ color: 'rgba(0, 0, 0, 0.45)', marginLeft: 6 }} />}
          </div>
        </Popover>
      }
    </>
  );
}

function ResourceShowList({ title, itemList }) {
  const colorType = title === '素材规则' ? 'blue' : title === '关联规则' ? 'yellow' : null;
  return (
    <>
      {itemList && Array.isArray(itemList) && itemList.length > 0 ? (
        <div className="resource-show-list-show-source-list">
          <div className="show-source-list-header">{title}</div>
          <div className="show-source-list-main">
            {itemList.map((item, index) => {
              return (
                <div className={classNames('show-source-list-item', colorType)} key={index}>
                  {item}
                </div>
              );
            })}
          </div>
        </div>
      ) : null}
    </>
  );
}
